export default __webpack_public_path__ + "static/media/warning--horizontal-alignment-left--g3.fa116178.png";